import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class GetArticlePriceListResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                'article_price_list': [
                    {
                        'article': {
                            'code': '4233',
                            'name': 'Baguette',
                            'fantasy_name': 'Baguette',
                            'items_amount': 20,
                            'category': 'Panadería Francesa',
                            'description': 'Descripción',
                            'weight': '20kg',
                            'measures': '20cm',
                            'cooking_time': '45 minutos',
                            'cooking_temperature': '200',
                            'ingredients': 'Harina',
                            'file': 'img.jpg',
                        },
                        'price': {
                            'amount': 5,
                            'currency': 'ARS'
                        }
                    }
                ],
            },
            errors: []
        }
    }

    articlePriceList() {
        return this.content().article_price_list.map(priced_article => {
            return {
                article: this._adaptArticle(priced_article.article),
                price: this._adaptPrice(priced_article.price),
            }
        });
    }

    _adaptArticle(article) {
        return {
            'code': article.code,
            'name': article.name,
            'fantasyName': article.fantasy_name,
            'itemsAmount': article.items_amount,
            'category': article.category.name,
            'description': article.description,
            'weight': article.weight,
            'measures': article.measures,
            'cookingTime': article.cooking_time,
            'cookingTemperature': article.cooking_temperature,
            'ingredients': article.ingredients,
            'file': article.file,
        }
    }

    _adaptPrice(price) {
        return {
            'amount': price.amount,
            'currency': price.currency,
        }
    }
}